import { createApi } from "@reduxjs/toolkit/query/react";

import type { ProviderStatusDTO } from "../../../../common/types/ProviderStatusDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export type { ProviderStatusDTO as ProviderStatus } from "../../../../common/types/ProviderStatusDTO";

export const statusService = createApi({
  reducerPath: "statusService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  endpoints: (builder) => ({
    getProviderStatuses: builder.query<ProviderStatusDTO[], void>({
      query: () => "api/status/providers",
    }),
  }),
});

export const { useGetProviderStatusesQuery } = statusService;
